import { localized, msg, str } from "@lit/localize";
import WhilecatStyle from "@whilecat/core/whilecat-style.js";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@whilecat/core/shoe.ts";

@localized()
@customElement("progress-bar")
export class ProgressBar extends LitElement {
    static styles = [
        WhilecatStyle,
        css`
          :host {
            width: 100%;
          }

          .progress-container {
            display: flex;
            flex-direction: column;
            gap: 10px;
            width: 100%;
            z-index: 2;
          }

          .progress-status-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }

          .progress-status {
            font-size: 11px;
          }

          .progress {
            width: 100%;
            --height: 6px;
            --indicator-color: var(--whilecat-primary);
            --track-color: var(--whilecat-dark-2);
            --label-color: var(--whilecat-light-3);
          }

          .progress-completed {
            --indicator-color: var(--whilecat-success-color-1);
          }

          .compact {
            --height: 12px;
          }

        `,
    ];

    @property({ type: Number }) completedLessons!: number;
    @property({ type: Number }) totalLessons!: number;
    @property({ type: Boolean }) compact!: boolean;

    render() {
        const completionPercent = Math.round(100.0 * (this.completedLessons / this.totalLessons));
        const completed = this.completedLessons === this.totalLessons;
        const text = completed ? msg("Completed") : msg("In progress");
        const className = completed ? "progress-completed" : "";

        if (this.compact) {
            return html`
              <div class="progress-container">
                  <sl-progress-bar class="progress compact ${className}" value="${completionPercent}">
                    ${msg(str`${this.completedLessons} of ${this.totalLessons}`)}
                  </sl-progress-bar>
              </div>
            `;
        }

        return html`
          <div class="progress-container">
              <div class="progress-status-container">
                <div class="progress-status">${text}</div>
                <div class="progress-status">${completionPercent}%</div>
              </div>
              <sl-progress-bar class="progress ${className}" value="${completionPercent}">
              </sl-progress-bar>
          </div>
        `;
    }
}
